import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useStateStore = defineStore('state', () => {
    const apiUrl = process.env.VUE_APP_API_URL
    const events = ref([])
    const currentEventId = ref(null)
    const currentEvent = ref(null)
    const accessToken = ref(null)

    async function fetchMarkers(eventId) {
        try {
            const response = await fetch(`${apiUrl}/api/v1/events/${eventId}/markers`)
            if (!response.ok) {
                throw new Error('Network response was not ok')
            }
            const data = await response.json()
            currentEvent.value.markers = data
        } catch (error) {
            console.error('Error fetching markers:', error)
        }
    }

    async function fetchEvents() {
        // fetch(`${apiUrl}/api/v1/competitions/110455744c8cb1caf69b470312df3fc3611f1548`)
        fetch(`${apiUrl}/api/v1/events`)
            .then(response => response.json())
            .then(data => {
                events.value = data.sort((a, b) => {
                    const dateA = new Date(a.date_start || a.date);
                    const dateB = new Date(b.date_start || b.date);
                    return dateB - dateA;
                });
            })
            .catch(error => {
                console.error('Error fetching events:', error)
            })
    }
    function setCurrentEventId(eventId) {
        currentEventId.value = eventId
        if (eventId == null) {
            currentEvent.value = null
            return
        }
        const event = events.value.find(event => event.id == eventId)
        if (event) {
            currentEvent.value = event
            fetchMarkers(eventId)
        } else {
            console.error('Event not found:', eventId)
        }
    }

    function setAccessToken(token) {
        accessToken.value = token
    }

    return { events, currentEventId, currentEvent, accessToken, fetchEvents, setCurrentEventId, setAccessToken }
}
)